export default "__VITE_ASSET__CqRYVwgf__"